import * as React from 'react';
import { cn } from '@/lib/utils';

const DashboardSection = React.forwardRef(({ className, ...props }, ref) => (
  <section
    ref={ref}
    className={cn(
      'c-dashboard-section',
      // styles
      'mb-10 flex flex-col gap-3',
      className
    )}
    {...props}
  />
));
DashboardSection.displayName = 'DashboardSection';

const DashboardSectionTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn(
      'c-dashboard-section-title',
      // styles
      'mb-0 text-sm font-light text-neutral-dark',
      className
    )}
    {...props}
  />
));
DashboardSectionTitle.displayName = 'DashboardSectionTitle';

export { DashboardSection, DashboardSectionTitle };
